import './permissions.scss'
import Header from './components/Header'
import UsersTable from './components/UsersTable'
const Permissions = () => (
  <div className="permissions-page-container">
    <Header />
    <UsersTable />
  </div>
)

export default Permissions
